import axios from "axios";

import moment from "moment";
import Cookies from "universal-cookie";
import { logoutapi } from "service/Auth";
import CryptoJS from "crypto-js";

// Config
// import { COOKIE_EXPIRE } from "config";

import { history } from "helpers";
import { Toast } from "./toast";
import { CloseConsultationAppointment } from "service/Appointment";

//axios Instance
export const axiosInstance = axios.create({
  headers: {},
});

//token storage
export const saveToken = (token) => {
  return localStorage.setItem("token", token);
};

//get token
export const getToken = () => {
  return localStorage.getItem("token");
};

//logout
export const logout = () => {
  let result = logoutapi();
  axiosInstance.defaults.headers.common["Authorization"] = "";
  localStorage.clear();
  history.push("/");
  // window.location.reload(true);
  Toast({ type: "success", message: "Logged out successfully " });
};

export const setCookie = (name, value, expire = 10) => {
  console.log(value, "vavavva");
  const cookie = new Cookies();
  const expiredAt = moment().add(expire, "minute").format("YYYY-MM-DD hh:mm A");
  cookie.set(name, value, { path: "/", expires: new Date(expiredAt) });
};

export const getCookie = (name) => {
  if (!name) return;
  const cookie = new Cookies();
  return cookie.get(name);
};

export const removeCookie = (name) => {
  if (!name) return;
  const cookie = new Cookies();
  cookie.remove(name, { path: "/" });
};

//book appointment api call
export const CloseConsultionFunction = async (body) => {
  try {
    let response = await CloseConsultationAppointment(body);
    if (response?.status == 200) {
      return { response };
    }
  } catch (err) {
    Toast({ type: "error", message: err?.response?.data?.message });
  }
};

export const doseMaxValue = (value) => (value ? Number(value) <= 4 : true);



const SECRET_KEY = CryptoJS.SHA256("meradoc_auth").toString(); // must match backend
const IV = CryptoJS.enc.Hex.parse("00000000000000000000000000000000"); // static IV for AES

export const generateAccessToken = () => {
  const payload = {
    auth: "014fe47d36955f237a7229a8b271b404",
    timestamp: Date.now(),
  };

  const data = JSON.stringify(payload);

  const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Hex.parse(SECRET_KEY), {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString(); // base64
};

